import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors, FormArray, FormControl } from '@angular/forms';
import { DataserviceService } from 'src/app/dataservice.service';
import { NzMessageService } from 'ng-zorro-antd/message';

export function ssnValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) return null;
  const digitsOnly = String(control.value).replace(/\D/g, '');
  return digitsOnly.length === 4 || digitsOnly.length === 9 ? null : { invalidSsn: true };
}

@Component({
  selector: 'app-dish-qual',
  templateUrl: './dish-qual.component.html',
  styleUrl: './dish-qual.component.css'
})
export class DishQualComponent {
  @Input() fullData: any;
  @Output() qualResponse = new EventEmitter<any>();

  qualForm: FormGroup;
  cardForm: FormGroup;
  needVerify = false;
  needCard = false;
  currentUser: any;
  leadId: any;
  customerType: any;
  qualifiedPromotion: any;
  qualResult: any = null;
  qualResp: any;
  questions: any;
  verifyModal: boolean = false;
  verifyForm: FormGroup;
  // Back-compat shim for older template bindings
  answers: Record<number, number> = {};
  notQualified: any;
  failedVerify: boolean = false;
  loadingId: any;
  loading: boolean = false;
  continueLoading: boolean = false;
  verifyLoading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private data: DataserviceService,
    private message: NzMessageService
  ) {
    this.qualForm = this.fb.group({
      qualCheck: [false, [Validators.requiredTrue]],
      ssn: ['', [Validators.required, ssnValidator]]
    });

    this.cardForm = this.fb.group({
      number: ['', []],
      exp: ['', []],
      cvv: ['', []],
    });

    this.verifyForm = this.fb.group({
      selections: this.fb.array([])
    });

    this.qualForm.get('qualCheck')?.valueChanges
      .subscribe(val => {
        if (val) {
          this.qualForm.get('ssn')?.setValidators([Validators.required, ssnValidator]);
        } else {
          this.qualForm.get('ssn')?.setValidators([ssnValidator]);
          this.qualForm.patchValue({ ssn: '' }, { emitEvent: false });
          this.resetQualState();
        }
        this.qualForm.get('ssn')?.updateValueAndValidity({ emitEvent: false });
      })
  }

  trackByIndex(index: number, item: any) {
    return item?.QuestionNumber ?? index;
  }

  cancel() {
    this.verifyModal = false;
  }

  qualifyFn() {
    if (!this.fullData) {
      alert('No customer info provided.');
      return;
    }

    this.resetQualState();
    this.loading = true;
    this.message.remove(this.loadingId)
    this.loadingId = this.message.loading('Qualifying lead...', { nzDuration: 0 }).messageId;

    const rawDob = this.fullData.dob || this.fullData?.customerInfo?.dob;
    console.log(rawDob)
    const dateObj = rawDob.split('-');
    const dobMonth = dateObj[1]
    const dobDay = dateObj[2]
    const dobYear = dateObj[0]

    let obj: any = {
      product: 'dish',
      customer_id: this.fullData.customerId,
      first: this.fullData.firstName || this.fullData?.customerInfo?.firstName,
      last: this.fullData.lastName || this.fullData?.customerInfo?.lastName,
      user_id: this.currentUser?.id,
      social: String(this.qualForm.get('ssn')?.value || '').replace(/\D/g, ''),
      month: dobMonth,
      day: dobDay,
      year: dobYear,
      conversationId: this.fullData.conversationId,
      promoId: this.fullData?.promoId || null
    };

    this.data.postDataNoBodyDotBody(obj, 'dish/qualifyCustomer')
      .subscribe({
        next: (res: any) => {
          console.log(res)
          obj.data = res.data;
          this.message.remove(this.loadingId)
          this.loadingId = this.message.loading('Getting response from dish...', { nzDuration: 0 }).messageId;
          this.data.postDataNoBodyDotBody(obj, 'qualify/create')
            .subscribe({
              next: (res2: any) => {
                if (res.result == 'success') {
                  this.handleQualSuccess(res);
                } else {
                  this.handleQualError(res);
                }
              }
            })
        },
        error: (err: any) => {
          console.log(err)
          this.loading = false;
          this.message.remove(this.loadingId)
          alert('Failed to qualify lead, please verify information and try again.')
        }
      })
  };

  handleQualError(q: any) {
    const code = q.data?.Status?.StatusCode
    //This is flex24/Not qualified
    if (code != 1080 && code != 1026) {
      this.notQualified = q?.data?.Status?.PromptMessage || 'Unable to qualify, additional information may be required.';
      //ID Verify
    } else if (code == 1026) {
      this.needVerify = true;
      this.notQualified = q?.data?.Status?.PromptMessage;
    }
    //need to handle credit card

    setTimeout(() => {
      this.loading = false;
      this.message.remove(this.loadingId)
    }, 250)
  }

  handleQualSuccess(q: any) {
    if (q?.data) {
      this.qualResp = q?.data?.QualifyCustomerResponse?.PromotionQualificationList?.PromotionQualification?.[0] || null;
      this.leadId = q?.data?.QualifyCustomerResponse?.LeadId || null;
      this.customerType = q?.data?.QualifyCustomerResponse.CustomerType || null;
      const promo = q?.data?.QualifyCustomerResponse.PromotionQualificationList?.PromotionQualification?.[0];
      this.qualifiedPromotion = promo?.PromotionName || promo?.GiftValue || null;
      this.qualResult = q?.data?.QualifyCustomerResponse;
    }


    setTimeout(() => {
      this.loading = false;
      this.message.remove(this.loadingId)
    }, 250)
  }

  resetQualState() {
    this.notQualified = null;
    this.customerType = null;
    this.qualifiedPromotion = null;
    this.needVerify = false;
    this.failedVerify = false;
    this.qualResp = null;
    this.qualResult = null;
    this.leadId = null;
  }

  private getDishProviderId(): string | null {
    if (this.currentUser?.providers && Array.isArray(this.currentUser.providers)) {
      const dishProvider = this.currentUser.providers.find((p: any) =>
        (p?.name || '').toLowerCase() === 'dish'
      );
      return dishProvider?.id || dishProvider?.provider_id || null;
    }
    return null;
  }

  continue() {
    this.continueLoading = true;
    this.message.remove(this.loadingId)
    this.loadingId = this.message.loading('Submitting qualification details...', { nzDuration: 0 }).messageId;

    const obj = {
      status: 'pending',
      customer_id: this.fullData.customerId,
      user_id: this.currentUser?.id,
      provider: 'dish',
      provider_id: this.getDishProviderId(),
      company_id: this.currentUser?.company_id,
      distributor_id: this.currentUser?.distributor_id,
      generic: {
        scrubAddressResponse: this.fullData.scrubAddressResponse,
        authenticateCustomerResponse: this.fullData.authenticateCustomerResponse.AuthenticateCustomerResponse,
        conversationId: this.fullData.conversationId
      },
    }
    this.data.postDataNoBodyDotBody(obj, 'work-order/create')
      .subscribe((r: any) => {
        this.message.remove(this.loadingId)
        this.qualResponse.emit({
          success: true,
          leadId: this.leadId,
          customerType: this.customerType,
          conversationId: this.fullData.conversationId,
          promotions: this.qualifiedPromotion,
          promoId: this.qualResp?.QualifiedPromotionId || this.qualResp?.PromotionID,
          promoName: this.qualResp?.PromotionName || null,
          woId: r.data?.id
        });

      },
        (e) => {
          console.error('Work order error:', e);
          alert('Failed to create work order.');
          this.continueLoading = false;
          this.message.remove(this.loadingId)
        }
      );
  }

  handleIDVerify() {
    this.message.remove(this.loadingId)
    this.loadingId = this.message.loading('Getting questions...', { nzDuration: 0 }).messageId;
    this.verifyLoading = true;
    this.data.postDataNoBodyDotBody({ conversationId: this.fullData.conversationId }, 'qualify/getVerificationQuestions').subscribe(
      (r) => {
        if (r.data?.data?.getVerificationQuestionsResponse?.VerificationQuestion?.length > 0) {
          this.verifyModal = true;
          this.questions = r.data.data.getVerificationQuestionsResponse.VerificationQuestion;
          this.rebuildVerifyForm();
        } else {
          this.needVerify = false;
          this.notQualified = 'Customer identity not verified. Please confirm their info is correct and resubmit.'
        }
        setTimeout(() => {
          this.verifyLoading = false;
          this.message.remove(this.loadingId)
        }, 200)
      },
      (e) => {
        console.error('Verification question error:', e);
        alert('Could not load verification questions.');
        this.verifyLoading = false;
        this.message.remove(this.loadingId)
      }
    );
  }

  private rebuildVerifyForm() {
    const arr = this.fb.array([] as FormControl[]);
    //clearing it IF it already has stuff in it.
    arr.clear();

    (this.questions || []).forEach(() => arr.push(new FormControl(null, Validators.required)));
    this.verifyForm.setControl('selections', arr);
  }

  get selections(): FormArray {
    return this.verifyForm.get('selections') as FormArray;
  }

  submitQuestions() {
    if (this.verifyForm.invalid) {
      this.verifyForm.markAllAsTouched();
      return;
    }

    this.message.remove(this.loadingId)
    this.loadingId = this.message.loading('Submitting answers...', { nzDuration: 0 }).messageId;
    const q = this.questions || [];

    const selections = this.selections.value.map((value: number | string | null) =>
      value !== null ? Number(value) : null
    ) as (number | null)[];

    const payload = {
      number: q[0]?.QuestionNumber ?? 1,
      choice: selections[0] ?? 1,
      number2: q[1]?.QuestionNumber ?? 2,
      choice2: selections[1] ?? 1,
      number3: q[2]?.QuestionNumber ?? 3,
      choice3: selections[2] ?? 1,
      conversationId: this.fullData.conversationId
    };

    this.data.postDataNoBodyDotBody(payload, 'qualify/answerVerificationQuestions').subscribe(
      (r: any) => {
        if (r.data?.getVerificationQuestionsResponse?.VerificationQuestion) {
          setTimeout(() => {
            this.message.remove(this.loadingId)
            alert('Second set of questions required!')
          }, 100)
          this.questions = r.data?.getVerificationQuestionsResponse.VerificationQuestion;
          this.rebuildVerifyForm();

        } else if (r.data?.answerVerificationQuestionsResponse?.VerificationStatus?.toUpperCase() == 'PASSED') {

          this.notQualified = null;
          this.needVerify = false;
          this.needCard = false;
          //gets a little wonky ui wise if we close fast
          setTimeout(() => {
            this.verifyModal = false;
          }, 200)

          // this.globalService.updateMessage('Qualifying with answers...')
          this.qualifyFn();

        } else {
          this.verifyModal = false;
          this.failedVerify = true;
          this.notQualified = r.data?.answerVerificationQuestionsResponse?.VerificationStatus || 'ID Verify Failed';
          setTimeout(() => {
            this.message.remove(this.loadingId)
          }, 200)
        }
      },
      (e) => {
        console.error('Verification answer error:', e);
        this.message.remove(this.loadingId)
      }
    );
  }
}
